import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nd-layout',
  templateUrl: './nd-layout.component.html',
  styleUrls: ['./nd-layout.component.css']
})
export class NdLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
